import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VendorsRoutingModule } from './vendors-routing.module';
import {VendorsComponent} from "./vendors.component";
import {VendorsEditComponent} from "./vendors-edit/vendors-edit.component";
import {VendorsViewComponent} from "./vendors-view/vendors-view.component";
import {VendorsFilterComponent} from "./vendors-filter/vendors-filter.component";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {MatTooltipModule} from "@angular/material/tooltip";
import {PipesModule} from "../pipes/pipes.module";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {SharedModule} from "../shared/shared.module";
import {UtilsModule} from "../utils/utils.module";
import {FilesModule} from "../files/files.module";
import {MatComponentsModule} from "../mat-components/mat-components.module";
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import { VendorsImporterComponent } from './vendors-importer/vendors-importer.component';


@NgModule({
  declarations: [
    VendorsComponent,
    VendorsEditComponent,
    VendorsViewComponent,
    VendorsFilterComponent,
    VendorsImporterComponent
  ],
  imports: [
    CommonModule,
    VendorsRoutingModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    PipesModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    UtilsModule,
    BsDatepickerModule,
    MatComponentsModule,
    SharedModule,
    FilesModule
  ]
})
export class VendorsModule { }
